import React from 'react'
import Link from 'next/link'
import Productimage from './productimage';
import Price from './price';
import WishListButton from '../../wishlist/gridbutton'
import BuyButton from './buybutton';

function Item({ item, loading, iscrosssell=false }) {
    return (
        <Link href={(item.role == 'merchant') ? ("/merchant/product/" + item.url) : ("/product/" + item.url)}>
            <a className="product_item_holder flex flex-col justify-between bg-white shadow rounded-lg p-5 relative border-2 border-white hover:border-brand-secondary active:border-brand-primary focus:border-brand-tertiary focus:ring-2 focus:ring-brand-tertiary transition-all">
                <div className="product_item_wrap">
                    <div className="product_image mb-4 text-center">
                        <Productimage item={item}></Productimage>
                    </div>
                    <div className='product_info'>
                        <p className="mx-3 mb-2 text-gray-900 text-sm font-medium">
                            {item.name}
                        </p>
                        <div className="mx-3 mb-6">
                            {(loading) ? (<span className="text-sm text-gray-500 italic">Loading prices..</span>) : (<Price item={item} loading={loading} iscrosssell={iscrosssell} ></Price>)}
                        </div>
                    </div>
                </div>
                <div className='btn_wish'>
                    <WishListButton product_id={item.id} url={item.url} is_fav={item.isFav}></WishListButton>
                </div>
                <BuyButton item={item} iscrosssell={iscrosssell}></BuyButton>
            </a>
        </Link>
    );
}

export default Item;